// Ícones do sistema visual Usina (mesmos paths do usina.js), como componentes React.
import type { SVGProps } from 'react';

const base: SVGProps<SVGSVGElement> = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round', strokeLinejoin: 'round' };

export const IconNodes = () => <svg {...base}><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M8 20h8M12 16v4" /></svg>;
export const IconChat = () => <svg {...base}><path d="M4 5h16v11H9l-5 4z" /></svg>;
export const IconKey = () => <svg {...base}><circle cx="8" cy="12" r="4" /><path d="M12 12h9M18 12v3M15 12v2" /></svg>;
export const IconUsage = () => <svg {...base}><path d="M4 20V10M10 20V4M16 20v-8M22 20H2" /></svg>;
export const IconUser = () => <svg {...base}><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.5-7 8-7s8 3 8 7" /></svg>;
export const IconPlus = () => <svg {...base}><path d="M12 5v14M5 12h14" /></svg>;
export const IconClip = () => <svg {...base}><path d="M16 6l-8.5 8.5a3 3 0 104.2 4.2L20 10.5a5 5 0 10-7-7L5.5 11" /></svg>;
export const IconSend = () => <svg {...base}><path d="M4 12l16-8-6 16-2-6z" /></svg>;

export const BrandMark = () => (
  <svg viewBox="0 0 26 26" fill="none" stroke="var(--fil)" strokeWidth={1.6} strokeLinejoin="round">
    <path d="M13 2.5l9.1 5.25v10.5L13 23.5l-9.1-5.25V7.75z" />
    <path d="M13 8v10M9.5 10l7 6M16.5 10l-7 6" stroke="var(--ink)" strokeWidth={1.3} opacity={0.9} />
  </svg>
);
